import React from "react";
import { takeLatest, put, all } from "redux-saga/effects";
import { toast } from "react-toastify";

import history from "../../../services/history";
import HttpService from "../../../services/HttpService";
import {
	getPath,
	isMobile,
	setSessionStorageKey,
	getSessionStorageKey,
	redirectTo,
	removeStorageKey,
} from "../../../utils";

import {
	authenticateRequest,
	changeLoading,
	loadingSocialLogin,
	redirectAuthenticatedRequest,
	respRequestError,
	setAuthenticated,
	setNewUsername,
	setRecaptchaError,
	showMessageLoginFail,
	showModalSocialLogin,
	trackEvent,
	logoutAndLoginForced as logoutTogetherLoginForced,
} from "./actions";

import { changeLoading as changeLoadingRegister, loginByOnboardGogogoRequest } from "../register/actions";

import { setDataLoginRequest } from "../sessionStorage/actions";

import { generatePathToLogin } from "../../../utils/generateRedirectLoginPath";
import { sendingToMarket } from "../register/actions";
import { handleAdjustEventRequest } from "../adjust/action";
import config from "../../../config/ConfigApplication";
import { Button } from "react-bootstrap";

let counter = 0;
let counterLogin = 0;
export function* authenticate({ payload }) {
	try {
		const { cpf, password, isProAuth, options, toMarket, tokenRecaptcha, adid: idAdjust } = payload;
		yield put(changeLoading(true));
		yield put(respRequestError(false));
		yield put(setRecaptchaError(false));

		if (localStorage.getItem("SET_ZERO")) {
			counter = 0;
			localStorage.removeItem("SET_ZERO");
		}

		const resp = yield HttpService.login(cpf, password, tokenRecaptcha ? tokenRecaptcha : {});

		if (!resp) throw resp;

		const blockList = ["USER_PASS_CHECK_FAILED", "USER_CANCELED", "USER_NOT_FOUND", "BLOCKED_PASSWORD"];
		if (!resp.success && resp.code && ["RECAPTCHA_VALIDATION_ERROR"].includes(resp.code)) {
			yield put(setRecaptchaError(true));
			yield put(changeLoading(false));
			toast.error(
				"Não foi possível validar o reCaptcha, verifique se não há bloqueadores em seu navegador. Se o problema persistir, entre em contato com o atendimento",
				{ autoClose: 30000 }
			);

			console.error("[CAPTCHA ERROR]", resp);
			throw resp;
		}

		if (!resp.success && resp.code && blockList.includes(resp.code)) {
			yield put(respRequestError(true));
			yield put(changeLoading(false));
			yield put(setRecaptchaError(false));

			history.push(redirectTo());
			if (["USER_CANCELED", "BLOCKED_PASSWORD"].includes(resp.code)) {
				return showToast("recoverAccount");
			}

			counter++;
			if (counter >= 5) {
				const block = yield HttpService.updateAccountStatus(cpf);

				if (block.code === "USER_NOT_FOUND") {
					return showToast();
				}

				return showToast("recoverAccount");
			} else {
				yield put(showMessageLoginFail(true));
				throw resp;
			}

			function showToast(params) {
				const sendForSupport = () => {
					window.open(
						`https://api.whatsapp.com/send?phone=5511943824762&text=Ol%C3%A1!%0AEstou%20com%20dificuldade%20para%20acessar%20através%20do%20login%20"${cpf}".%20Pode%20me%20ajudar?`,
						"_blank"
					);
				};

				const sendToRecoverPassword = () => {
					localStorage.setItem("appflow", "RECOVER");
					history.push("/onboard/welcome-register");
				};

				if (params === "recoverAccount") {
					// REVER
					const message = () => (
						<div>
							<span>
								Sua senha foi bloqueada após muitas
								tentativas.&nbsp; Por favor,
								<Button
									variant="link"
									style={{
										padding: "0",
										textDecoration:
											"underline",
										fontWeight: "bold",
										color: "#FFF",
									}}
									onClick={() =>
										sendToRecoverPassword()
									}
								>
									crie outra senha&nbsp;
								</Button>
								:)&nbsp;
							</span>
						</div>
					);
					return toast.error(message, { autoClose: 30000 });
				}

				const message = () => (
					<div>
						<span>
							Está com dificuldade para entrar na sua
							conta?&nbsp;
							<Button
								variant="link"
								style={{
									padding: "0",
									textDecoration: "underline",
									fontWeight: "bold",
									color: "#FFF",
								}}
								onClick={() => sendForSupport()}
							>
								Fale com a gente&nbsp;
							</Button>
							pelo WhatsApp, vamos te ajudar!
						</span>
					</div>
				);
				return toast.error(message, { autoClose: 30000 });
			}
		}

		if (!resp.success) throw resp;

		if (resp.success) {
			const otherSessionActicve = resp["result"]["investor"].another_session_removed;
			localStorage.setItem("OTHER_SESSION_ACTICVE", otherSessionActicve);

			let {
				billingStatus,
				investor,
				multiBroker,
				cd_access_token,
				accounts,
				guardStatus,
				tradeChat,
			} = resp.result;

			const idInfluencerLink = localStorage.getItem("FLUX_INFLUENCER");

			if (idInfluencerLink) {
				yield put(
					handleAdjustEventRequest({
						signupStage: "",
						loginData: resp.result,
						idAdjust,
						idInfluencerLink,
					})
				);
				return;
			}

			yield put(
				redirectAuthenticatedRequest(
					billingStatus,
					investor,
					multiBroker,
					cd_access_token,
					accounts,
					guardStatus,
					isProAuth,
					options,
					toMarket,
					tradeChat
				)
			);

			const remove = ["tm:TIME", "tm:MESSAGE_ERROR"];

			for (let value of remove) {
				removeStorageKey(value);
			}

			return;
		}
	} catch (err) {
		let message = "Ocorreu um erro. Tente novamente mais tarde ou entre em contato com o suporte.";

		if (err && err.message && !String(err.message).includes("ERROR:")) {
			message = err.message;
		}

		if (err && ["INTERNAL_SERVER_ERROR"].includes(err.code) && counterLogin <= 1) {
			counterLogin++;
			message = "";

			yield put(
				logoutTogetherLoginForced({
					reason: "Logout forçado após erro interno na API do login",
					newLogin: payload,
				})
			);

			return;
		}

		if (message.length) {
			toast.error(message);
		}

		console.error("[LOGIN ERROR]", err);
		yield put(changeLoading(false));
		yield put(respRequestError(true));

		history.push(redirectTo());
	}
}
/**
 *
 * @param {{reason: string, newLogin: any, isLoginAfterOnboarding?: boolean}} payload
 */
function* logoutAndLoginForced({ payload }) {
	try {
		const { reason, newLogin, isLoginAfterOnboarding } = payload;

		const resp = yield HttpService.logout(reason);

		if (!resp.success) throw resp;

		const { cpf, password, isProAuth, options, toMarket, tokenRecaptcha, adid: idAdjust } = newLogin;

		if (newLogin) {
			if (!isLoginAfterOnboarding) {
				yield put(
					authenticateRequest(
						cpf,
						password,
						isProAuth,
						options,
						toMarket,
						tokenRecaptcha,
						idAdjust
					)
				);
			} else {
				yield put(loginByOnboardGogogoRequest(password, null, tokenRecaptcha));
			}

			return;
		}

		history.push(redirectTo());
	} catch (error) {
		console.error("[LOGOUT FORCED ERROR]", error);
		yield put(changeLoading(false));
		yield put(changeLoadingRegister(false));
	}
}

export function* logout({ payload }) {
	try {
		const { reason } = payload;
		const resp = yield HttpService.logout(reason);

		if (!resp.success) throw resp;
	} catch (error) {
		console.error("[LOGOUT ERROR]", error);
	} finally {
		sessionStorage.clear();

		setTimeout(() => {
			history.push("/onboard/login");
		}, 2000);
	}
}

export function* socialMediaAuthenticate({ payload }) {
	try {
		const { cpf, password, sso, sig } = payload;
		const resp_login = yield HttpService.login(cpf, password);
		if (resp_login.code && resp_login.code === "USER_PASS_CHECK_FAILED") {
			yield put(showMessageLoginFail(true));
			yield put(changeLoading(false));
			return;
		}
		if (resp_login.success) {
			const resp = yield HttpService.authenticateSocialMediaLogin(sso, sig);
			const { result } = resp;
			if (result.success === true) {
				window.location.replace(
					"https://comunidade.trademap.com.br/session/sso_login?sso=" +
						result.sso +
						"&sig=" +
						result.hash
				);
			} else {
				throw Error({ message: "Erro na autenticação" });
			}
		}
	} catch (error) {
		let message = error.message || "Não foi possível efetuar o login. Por gentileza tente novamente.";
		toast.error(message);
	}
}

export function* redirectAuthenticated({ payload }) {
	try {
		sessionStorage.removeItem("guardStatus");
		const { billingStatus, investor, multiBroker, accounts, guardStatus, isProAuth, toMarket } =
			payload;
		setSessionStorageKey("guardStatus", guardStatus);
		setSessionStorageKey("CLIENT_AUTH", JSON.stringify(investor));

		yield put(trackEvent(investor.id_investor));
		yield put(setDataLoginRequest(investor, multiBroker, billingStatus, accounts));

		if (localStorage.getItem("CACHEDPLAN") || localStorage.getItem("flow-checkout-plan")) {
			localStorage.removeItem("CACHEDPLAN");
			localStorage.removeItem("flow-checkout-plan");
			triggerEventAtCheckout();
			window.location.href = getPath("/onboarding/carrinho/plano");
			return;
		}

		if (localStorage.getItem("flow-reactive-plan")) {
			localStorage.removeItem("flow-reactive-plan");
			history.push({
				pathname: "/onboard/reativar-plano",
				state: { investor: investor.name },
			});
			return;
		}

		if (localStorage.getItem("flow-aproveite-agora")) {
			yield put(setDataLoginRequest(investor, multiBroker, billingStatus, accounts));
			localStorage.removeItem("flow-aproveite-agora");
			const plan = getSessionStorageKey("PLANSELECTED");
			history.push(`/onboard/aproveite-agora-checkout/${plan.cd_product}`);
			return;
		}

		if (localStorage.getItem("flow-market-place")) {
			yield put(setDataLoginRequest(investor, multiBroker, billingStatus, accounts));
			localStorage.removeItem("flow-market-place");
			const plan = getSessionStorageKey("PLANSELECTED");
			history.push(`/onboard/market-place-details/${plan.cd_product}`);
			return;
		}

		if (localStorage.getItem("flow-feature")) {
			yield put(setDataLoginRequest(investor, multiBroker, billingStatus, accounts));
			localStorage.removeItem("flow-feature");
			history.push("/onboard/checkout-details/feature");
			return;
		}

		if (localStorage.getItem("flow-checkout")) {
			yield put(setDataLoginRequest(investor, multiBroker, billingStatus, accounts));
			localStorage.removeItem("flow-checkout");
			triggerEventAtCheckout();
			window.location.href = getPath("/onboarding/carrinho/combo");
			return;
		}

		if (
			sessionStorage.getItem("CREATING_BY") &&
			sessionStorage.getItem("CREATING_BY").includes("EducaMap")
		) {
			window.location.href = `//${config.educaRedirect}/login`;
			sessionStorage.removeItem("CREATING_BY");
			return;
		}

		// plan-update
		if (isMobile.any()) {
			history.push("/onboard/redirecionar-loja");
			return;
		} else {
			yield put(setDataLoginRequest(investor, multiBroker, billingStatus, accounts));
			var path = generatePathToLogin(investor.token);

			if (isProAuth) {
				path = `/carregando-portal/${investor.token}/plan-update`;
			}

			if (toMarket) {
				yield put(sendingToMarket(false));
				triggerEventAtCheckout();
				path = "/onboarding/planos";
			}

			window.location.href = getPath(path);
			return;
		}
	} catch (err) {
		console.error("[REDIRECT ERROR]", err);
		let message = err.message || "Não foi possível efetuar o login. Por gentileza tente novamente.";
		toast.error(message);
	}
}

export function* loginWithTokenByRedirect({ payload }) {
	try {
		yield put(changeLoading(true));
		const { token, redirect } = payload;

		yield put(setAuthenticated(true));
		const response = yield HttpService.loginWithToken(token);
		if (!response.success) {
			throw response;
		} else {
			const responseToken = yield HttpService.scheduleHealthCheckAuthenticationWs();

			if (!responseToken.success) {
				throw response;
			}

			const { investor, guardStatus } = response.result;

			setSessionStorageKey("guardStatus", guardStatus);
			setSessionStorageKey("CLIENT_AUTH", investor);
			setSessionStorageKey("TOKEN", response.result.investor.token);
			setSessionStorageKey("USING_REACT_ONBOARD", response.result);

			yield put(changeLoading(false));
			triggerEventAtCheckout();
			window.location.href = getPath(redirect);
		}
	} catch (e) {
		history.push("/onboard/login?flux-promotional=redirect");
		console.error("[LOGIN-WITH-TOKEN-CHECKOUT]", e);
		// toast.error('Não foi possível fazer a autenticação!');
		yield put(changeLoading(false));
		yield put(setAuthenticated(false));
	}
}

export function* loginWithTokenByRedirectPortal({ payload }) {
	yield put(changeLoading(true));
	const { token, redirect, redirectError } = payload;
	try {
		if (!Boolean(token)) {
			yield put(changeLoading(false));
			return;
		}
		const response = yield HttpService.loginWithToken(token);
		if (!response.success) {
			throw response;
		} else {
			const responseToken = yield HttpService.scheduleHealthCheckAuthenticationWs();
			// const preLogin = yield HttpService.preLoginExternal()
			if (!responseToken.success) {
				throw response;
			}

			const { investor, guardStatus } = response.result;

			setSessionStorageKey("guardStatus", guardStatus);
			setSessionStorageKey("CLIENT_AUTH", JSON.stringify({ ...investor }));
			setSessionStorageKey("TOKEN", investor.token);
			setSessionStorageKey("USING_REACT_ONBOARD", response.result);

			yield put(setAuthenticated(true));
			yield put(changeLoading(false));

			const redirectReplace = redirect.replace("{token}", investor.token);
			window.location.href = getPath(redirectReplace);
		}
	} catch (e) {
		toast.error("Não foi possível fazer a autenticação!");
		history.push(redirectError || "/onboard/login");
		yield put(changeLoading(false));
	}
}

export function* socialLogin({ payload }) {
	const { token, socialNetworkId, toMarket } = payload;
	try {
		yield put(setNewUsername(false));
		yield put(loadingSocialLogin(false));
		const resp = yield HttpService.socialLogin(token, socialNetworkId);

		if (resp.success) {
			let {
				billingStatus,
				investor,
				multiBroker,
				cd_access_token,
				accounts,
				guardStatus,
				tradeChat,
			} = resp.result;
			yield put(
				redirectAuthenticatedRequest(
					billingStatus,
					investor,
					multiBroker,
					cd_access_token,
					accounts,
					guardStatus,
					null,
					null,
					toMarket,
					tradeChat
				)
			);

			yield put(loadingSocialLogin(true));
		} else {
			yield put(loadingSocialLogin(true));
		}

		if (!resp.success && resp.code && resp.code.includes("SEND_TO_ONBOARD")) {
			localStorage.setItem("AUTHENTICATED", "LOGIN_SOCIAL_WITHOUT_EMAIL");
			yield put(showModalSocialLogin(true));
		}

		if (!resp.success && resp.code && resp.code.includes("USER_NOT_AUTHENTICATED")) {
			yield put(setNewUsername(true));
			yield put(loadingSocialLogin(true));
			yield put(showModalSocialLogin(false));
			localStorage.setItem("AUTHENTICATED", "SOCIAL_NOT_AUTHENTICATED");

			return toast.info("Identificamos sua conta, faça login para vincular a rede social!", {
				autoClose: 10000,
			});
		}
	} catch (error) {
		console.error("ERRO", error);
		toast.error("Não foi possivel fazer login");
	}
}

export default all([
	takeLatest("@auth/REDIRECT_AUTHENTICATED", redirectAuthenticated),
	takeLatest("@auth/AUTHENTICATE_REQUEST", authenticate),
	takeLatest("@auth/SOCIAL_MEDIA_AUTHENTICATE_REQUEST", socialMediaAuthenticate),
	takeLatest("@auth/LOGIN_WITH_TOKEN_BY_REDIRECT", loginWithTokenByRedirect),
	takeLatest("@auth/LOGIN_WITH_TOKEN_BY_REDIRECT_PORTAL", loginWithTokenByRedirectPortal),
	takeLatest("@auth/SOCIAL_LOGIN", socialLogin),
	takeLatest("@auth/LOGOUT", logout),
	takeLatest("@auth/LOGOUT_AND_LOGIN_FORCED", logoutAndLoginForced),
]);

function triggerEventAtCheckout() {
	setSessionStorageKey("TRIGGER_EVENT_AT_CHECKOUT", {
		isTriggerEvent: true,
		fluxUser: "NEW_LOGIN",
	});
}
